<template>
  <MainLayout selectMenu="7-1">
    <div v-if="!hasAuth">
      <NoAuth></NoAuth>
    </div>
    <div v-else>
      <WebSocket :url="webSocketUrl" @receive-message="receiveMessage"></WebSocket>
      <div class="select-all">
        <Checkbox :indeterminate="indeterminate" :value="checkAll" @click.prevent.native="handleCheckAll" size="small">
          {{ getTranslation('b056') }}
        </Checkbox>
      </div>
      <CheckboxGroup v-model="selectedItems">
      <fieldset class="my-fieldset first-fieldset">
        <legend class="my-legend">{{ getTranslation('i016') }}</legend>
        <div class="checkbox-section">

          
            <div class="checkbox-grid">
              <Row type="flex">
                <Col flex="8" @click.native="selectItem('record')">
                <div class="checkbox-item">
                  <Checkbox label="record" size="small" @click.native.stop>{{ getTranslation('i003') }}</Checkbox>
                </div>
                </Col>
                <Col flex="8" @click.native="selectItem('curve')">
                <div class="checkbox-item">
                  <Checkbox label="curve" size="small" @click.native.stop>{{ getTranslation('i004') }}</Checkbox>
                </div>
                </Col>
                <Col flex="8" @click.native="selectItem('alarm')">
                <div class="checkbox-item">
                  <Checkbox label="alarm" size="small" @click.native.stop>{{ getTranslation('i005') }}</Checkbox>
                </div>
                </Col>
              </Row>

              <Row type="flex">
                <Col flex="8" @click.native="selectItem('uircurve')">
                <div class="checkbox-item">
                  <Checkbox label="uircurve" size="small" @click.native.stop>{{ getTranslation('i006') }}</Checkbox>
                </div>
                </Col>
                <Col flex="8" @click.native="selectItem('modification')">
                <div class="checkbox-item">
                  <Checkbox label="modification" size="small" @click.native.stop>{{ getTranslation('i010') }}</Checkbox>
                </div>
                </Col>
                <Col flex="8" @click.native="selectItem('history')">
                <div class="checkbox-item">
                  <Checkbox label="history" size="small" @click.native.stop>{{ getTranslation('i011') }}</Checkbox>
                </div>
                </Col>
              </Row>
              <Row>
                <Col flex="8" @click.native="selectItem('expulsion_daily')">
                <div class="checkbox-item">
                  <Checkbox label="expulsion_daily" size="small" @click.native.stop>{{ getTranslation('e019') }}</Checkbox>
                </div>
                </Col>
                <Col flex="8" @click.native="selectItem('fix_alarm')">
                <div class="checkbox-item">
                  <Checkbox label="fix_alarm" size="small" @click.native.stop>{{ getTranslation('p050') }}</Checkbox>
                </div>
                </Col>
                <Col flex="8"></Col>
              </Row>
              <RadioGroup v-model="timeRange">
                <Row type="flex" class="time-range">
                  <Col flex="1">{{ getTranslation('i021') }}</Col>
                  <Col>
                  <Radio label="1 WEEK" border>{{ getTranslation('i034') }}</Radio>
                  </Col>
                   <Col>
                  <Radio label="1 MONTH" border>{{ getTranslation('i017') }}</Radio>
                  </Col>
                  <Col>
                  <Radio label="3 MONTH" border>{{ getTranslation('i018') }}</Radio>
                  </Col>
                  <Col>
                  <Radio label="6 MONTH" border>{{ getTranslation('i019') }}</Radio>
                  </Col>
                  <Col>
                  <Radio label="1 YEAR" border>{{ getTranslation('i020') }}</Radio>
                  </Col>
                </Row>
              </RadioGroup>
            </div>
        </div>
      </fieldset>
      <Row type="flex" class="second-section">
        <Col flex="1">
        <fieldset class="my-fieldset first-fieldset">
          <legend class="my-legend">{{ getTranslation('i022') }}</legend>
          <Row type="flex">
            <Col flex="8" @click.native="selectItem('system')">
            <div class="checkbox-item">
              <Checkbox label="system" size="small" @click.native.stop>{{ getTranslation('i009') }}</Checkbox>
            </div>
            </Col>
            <Col flex="8" @click.native="selectItem('library')">
            <div class="checkbox-item">
              <Checkbox label="library" size="small" @click.native.stop>{{ getTranslation('i007') }}</Checkbox>
            </div>
            </Col>
            <Col flex="8" @click.native="selectItem('specs')">
            <div class="checkbox-item">
              <Checkbox label="specs" size="small" @click.native.stop>{{ getTranslation('i008') }}</Checkbox>
            </div>
            </Col>
          </Row>
        </fieldset>
        </Col>
      </Row>
      </CheckboxGroup>
      <div class="warning-section">
        <Alert type="warning" show-icon class="warning-alert">
          {{ getTranslation('i012') }}
        </Alert>
      </div>
       <div class="warning-section">
        <Alert type="warning" show-icon class="warning-alert">
          {{ getTranslation('i029') }}
        </Alert>
      </div>

      <div class="action-section">
        <Button type="error" size="small" icon="md-trash" @click.native="clear()" class="delete-btn">
          {{ getTranslation('i002') }}
        </Button>
      </div>

    </div>
  </MainLayout>
</template>

<script>
import MainLayout from '@/components/MainLayout.vue'
import { API_URL } from '@/constants/const.js'
import axios from 'axios';
import { mapGetters } from 'vuex'
import NoAuth from '@/components/NoAuth.vue'
import { postJsError } from '@/util/util.js'
import WebSocket from '@/components/WebSocket.vue';

export default {
  name: 'MachineIndex', // 组件名称
  components: {
    MainLayout,  NoAuth, WebSocket
  },
  props: {

  },
  data() {
    return {
      selectedItems: [],
      checkAll: false,
      indeterminate: false,
      hasAuth: true,
      timeRange: '1 WEEK',
    }
  },
  computed: {
    ...mapGetters(['getTranslation']),
     webSocketUrl() {
          return API_URL['webSocket'];
      },
  },
  mounted() {

  },
  created() {
    this.setBreadcrumbItems();
    this.getData();
  },
  methods: {
    getData() {
      let url = API_URL["initInfo"];
      axios.get(url, {

      })
        .then(res => {
          if (res && res.data && res.data.code == 3001) {
            this.hasAuth = false;
          }
        })
        .catch((err) => {
          postJsError(err)
          this.$Message.error(this.getTranslation('c001'));
        })
    },
    handleCheckAll() {
      if (this.indeterminate) {
        this.checkAll = false;
      } else {
        this.checkAll = !this.checkAll;
      }
      this.indeterminate = false;

      if (this.checkAll) {
        this.selectedItems = ['record', 'curve', 'alarm', 'uircurve', 'library', 'specs', 'system', 'modification', 'history', 'expulsion_daily'];
      } else {
        this.selectedItems = [];
      }
    },

    clear() {
      if (this.selectedItems.length == 0) {
        this.$Message.error(this.getTranslation('b177'));
        return;
      }
      this.$Modal.confirm({
        title: "",
        content: this.getTranslation('m205'),
        okText: this.getTranslation('b181'),
        cancelText: this.getTranslation('b182'),
        onOk: () => {
          let url = API_URL["initClear"];
          let params = {
            db: this.selectedItems.join(","),
            timeRange: this.timeRange,
          }
          axios.get(url, {
            params: params
          })
            .then(res => {
              if (res && res.data && res.data.code == 200) {
                this.$Message.success(res.data.msg);
              } else if (res && res.data && res.data.msg) {
                this.$Message.error(res.data.msg);
              } else {
                this.$Message.error(this.getTranslation('c001'));
              }
            })
            .catch((err) => {
              postJsError(err)
              this.$Message.error(this.getTranslation('c001'));
            })
        }
      });
    },
    setBreadcrumbItems() {
      if (this.$lang && this.$lang['i001']) {
        this.$store.commit('setBreadcrumbItems', [
          { title: this.getTranslation('i001') }
        ])
      }      
    },
    selectItem(item) {
      const index = this.selectedItems.indexOf(item);
      if (index > -1) {
        this.selectedItems.splice(index, 1);
      } else {
        this.selectedItems.push(item);
      }

      const totalItems = ['record', 'curve', 'alarm', 'uircurve', 'library', 'specs', 'system', 'modification', 'history', 'expulsion_daily'];
      if (this.selectedItems.length === 0) {
        this.checkAll = false;
        this.indeterminate = false;
      } else if (this.selectedItems.length === totalItems.length) {
        this.checkAll = true;
        this.indeterminate = false;
      } else {
        this.checkAll = false;
        this.indeterminate = true;
      }
    },
    receiveMessage(obj){
       if (obj && obj.kind) {
          switch (obj.kind) {
              case 'notice':
                  this.$Message.info(obj.data.msg);
                  break;
          }
        }
    }
  },

}
</script>

<style scoped>
/* 卡片内部边框 */
@import url('../../assets/style/tab.css');

.checkbox-section {
  margin: 0px 0;
}

.select-all {
  margin-bottom: 10px;
  padding: 5px 0;
  border-bottom: 1px solid #e8e8e8;
}

.select-all>>>.ivu-checkbox-wrapper {
  font-size: 14px;
  color: #1890ff;
}

.checkbox-grid {
  margin-top: 0px;
}

.checkbox-item {
  margin-top: 8px;
  margin-right: 12px;
  padding: 8px 15px;
  background: #f8f9fa;
  border-radius: 8px;
  border: 1px solid #e9ecef;
  transition: all 0.2s ease;
}

.checkbox-item:hover {
  background: #e9ecef;
  border-color: #dee2e6;
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.checkbox-item>>>.ivu-checkbox-wrapper {
  font-size: 14px;
  font-weight: 500;
  color: #495057;
}

.checkbox-item>>>.ivu-checkbox-wrapper.ivu-checkbox-wrapper-checked {
  color: #1890ff;
  font-weight: 600;
}

.warning-section {
  margin: 24px 0;
}

.warning-alert {
  background: #fffbf0;
  border: 1px solid #ffe58f;
}

.warning-alert>>>.ivu-alert-icon {
  color: #faad14;
  font-size: 16px;
}

.warning-alert>>>.ivu-alert-message {
  color: #8c6b08;
  font-size: 13px;
  line-height: 1.5;
}

.action-section {
  display: flex;
  justify-content: center;
  margin: 20px 0;
}

.delete-btn {
  min-width: 120px;
  height: 30px;
  font-weight: 500;
  box-shadow: 0 2px 4px rgba(245, 34, 45, 0.3);
}

.delete-btn:hover {
  box-shadow: 0 4px 8px rgba(245, 34, 45, 0.4);
  transform: translateY(-1px);
}

.second-section {
  margin-top: 20px;
}
.time-range {
  margin-top: 10px;
}
</style>
